import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { BancoModel, PremioConsumidorModel } from '../../../shared';
import { PremioSorteioService } from '../../../shared/service/premio-sorteio.service';
import { ConsumidorService } from '../shared/consumidor.service';
import { ConsumidorModel } from './../shared/consumidor.model';
import { FiltroPremiacaoCidadao } from '../../../shared/model/filtro-premiacao-cidadao';

@Component({
  selector: 'app-consumidor-premios',
  templateUrl: './consumidor-premios.component.html',
  styleUrls: []
})
export class ConsumidorPremiosComponent implements OnInit, OnDestroy {
  @Input() public pagina: number;
  @Input() public tamanho: number;
  public totalPremios = 0;
  public _premios: PremioConsumidorModel[] = [];
  public _bancos: BancoModel[] = [];
  public _premiosSelecionados: PremioConsumidorModel[] = new Array<PremioConsumidorModel>();
  public indexARemover: number;
  public premioARemover: PremioConsumidorModel;
  public semRegistros = false;
  public notificacao: string;
  public _observer: Subscription;
  public frmListarPremios: FormGroup;
  public consumidor: ConsumidorModel;
  public unsub: Subscription;
  public unsub2: Subscription;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly premioSorteioService: PremioSorteioService,
    private readonly consumidorService: ConsumidorService
  ) {}

  ngOnInit() {
    this.pagina = this.route.snapshot.params['pagina'] || this.pagina || 1;
    this.tamanho = this.route.snapshot.params['tamanho'] || this.tamanho || 10;

    this.consumidor = this.consumidorService.getConsumidorModel();
    this.notificacao = 'Não foram encontrados prêmios para '.concat(this.consumidor.nome).concat('.');
    
    let filtro = new FiltroPremiacaoCidadao();
    filtro.consumidorId = this.consumidor.consumidorId;
    filtro.page = this.pagina;
    filtro.pageSize = this.tamanho;
    this.getPremiosApi(filtro);

    this.unsub2 = this.premioSorteioService.premioSorteioChange.subscribe((data: PremioConsumidorModel[]) => {
      this._premios = data;
      this.totalPremios = this.premioSorteioService.totalPremios;
      this.semRegistros = this._premios.length === 0;
    });
  }

  ngOnDestroy() {
    this.unsub2.unsubscribe();
  }

  private getPremiosApi(filtro: FiltroPremiacaoCidadao): void {

    this.premioSorteioService.getPremios(filtro);
  }

  public getPremios(): PremioConsumidorModel[] {
    return this._premios;
  }

  public pageChange(event: number): void {
    this.pagina = event;
    let filtro = new FiltroPremiacaoCidadao();
    filtro.consumidorId = this.consumidor.consumidorId;
    filtro.page = this.pagina;
    filtro.pageSize = this.tamanho;
    this.getPremiosApi(filtro);
  }

  public existePremio(): boolean {
    return this._premios ? this._premios.length > 0 : false;
  }

  public formatarData(data: Date): string {
    const d: Date = new Date(data);
    function pad(s) {
      return (s < 10 ? '0' : '') + s;
    }
    return [pad(d.getDay()), pad(d.getMonth() + 1), pad(d.getFullYear())].join('/');
  }

  public selecionarPremio(premio: PremioConsumidorModel, check: HTMLInputElement): void {
    if (check.checked) {
      this._premiosSelecionados = this._premiosSelecionados.concat(premio);
    } else {
      this.premioARemover = this._premiosSelecionados.filter(
        p => p.seqPremioSorteioPremiacaoConsumidor === premio.seqPremioSorteioPremiacaoConsumidor
      )[0];
      this.indexARemover = this._premiosSelecionados.indexOf(this.premioARemover);

      if (this.indexARemover !== -1) {
        this._premiosSelecionados.splice(this.indexARemover, 1);
      }
    }
  }

  public solicitarResgateClick() {
    this.premioSorteioService._premiosSelecionadosParaResgate = this._premiosSelecionados;
    this.router.navigate(['consumidor/resgate_premios']);
    let filtro = new FiltroPremiacaoCidadao();
    filtro.consumidorId = this.consumidor.consumidorId;
    filtro.page = this.pagina;
    filtro.pageSize = this.tamanho;
    this.getPremiosApi(filtro);
  }

  public premioSelecionado(premio: PremioConsumidorModel) {
    const premioEncontrado: PremioConsumidorModel = this._premiosSelecionados.find(
      p => p.seqPremioSorteioPremiacaoConsumidor === premio.seqPremioSorteioPremiacaoConsumidor
    );

    if (premioEncontrado !== null && premioEncontrado) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-premios/consumidor-premios.component.ts